import FilterReducer from "app/Core/Components/Filter/Store/Reducers/FilterReducer";
import TagFuncionalidadeReducer from "app/ERP/TagFuncionalidade/Store/Reducers/TagFuncionalidadeReducer";
import { combineReducers } from "redux";
import EmpresaPessoaReducer from "./EmpresaPessoaReducer";

const reducer = combineReducers({
    FilterReducer,
    EmpresaPessoaReducer,
    TagFuncionalidadeReducer
});

export default reducer;
